module.exports = __webpack_public_path__ + "img/arrow-right-from-line.db1ea098.svg";